export default "__VITE_ASSET__X4YrhgWA__"